<template>
  <div>
    <div v-if="loading">
      <span class="far fa-spinner fa-spin" />
    </div>
    <div v-else-if="error">Error load chat</div>
    <vis-chat
      :chatApi="chatApi"
      :authApi="profileApi"
      :visaryApi="visaryApi"
      :iceServers="iceServers"
      :assetsPath="assetsPath"
      :isAdmin="isAdmin"
      :isEmployee="isEmployee"
      :isManager="isManager"
      :isOperator="isOperator"
      :isSupervisor="isSupervisor"
      :logUrl="logUrl"
      :logLevel="logLevel"
      @loaded="onLoaded"
    />
  </div>
</template>

<script>
import VisChat from "@/views/vis-chat";
import globalState from "../shared/global-state";

// const securityStorageKey = "securityChat"; // Hide secret chat button

export default {
  name: "vis-chat-launcher",
  components: {
    VisChat
  },
  data() {
    return {
      profileApi: globalState.launchConfig?.chat.profileApiUrl,
      visaryApi: globalState.launchConfig?.chat.visaryApiUrl,
      iceServers: globalState.launchConfig?.chat.iceServers,
      assetsPath: globalState.launchConfig?.chat.assetsPath,
      isAdmin: globalState.currentUser?.IsAdmin || false,
      isEmployee: globalState.currentUser?.IsEmployee || false,
      isManager: globalState.currentUser?.IsManager || false,
      isOperator: globalState.currentUser?.IsOperator || false,
      isSupervisor: globalState.currentUser?.IsSupervisor || false,
      logUrl: globalState.launchConfig?.chat.logUrl,
      logLevel: globalState.launchConfig?.chat.logLevel,
      loading: true,
      error: false,
    };
  },
  computed: {
    chatApi() {
      return globalState.launchConfig?.chat?.chatApiUrl;
    }
  },
  methods: {
    onLoaded(error) {
      this.loading = false;
      this.error = !!error;
    }
  }
};
</script>
